import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { aboutUsContent } from "../redux/features/footerPages/footerPagesContentSlice";
import AboutHead from "../assets/img/about-2.jpg";
import { FaSpinner } from "react-icons/fa";

const AboutUs = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { aboutUsContent: data, status } = useSelector(
    (state) => state.footerPagesContent || {}
  );

  const lang = useSelector((state) => state.language.lang);
  const api_token = localStorage.getItem("api_token");

  useEffect(() => {
    dispatch(aboutUsContent({ api_token, lang }));
  }, [lang, api_token, dispatch]);

  if (status === "loading") {
    return (
      <div className="text-center my-5">
        <FaSpinner className="spin fs-2" />
      </div>
    );
  }

  if (!data) return null;

  return (
    <>
      {/* Header Section */}
      <div className="container-fluid faq-heading">
        <div className="row text-center">
          <h1>{data?.title || t("About-Us")}</h1>
          <p>{data?.sub_title}</p>
        </div>
      </div>

      {/* Section 1 - About Content */}
      <div className="m-0 p-md-3 p-2">
        <section className="container">
          <div className="row align-items-center">
            {/* Text Section */}
            <div className="col-lg-6 col-12 text-content px-3 mb-3 order-2 order-lg-1">
              <div
                className="text-muted fs-6"
                dangerouslySetInnerHTML={{ __html: data?.content || "" }}
              ></div>

              <div className="animate__animated animate__fadeInUp mt-3">
                <Link to="/contact-us">
                  <button className="btn theme-btn style-one btn-lg fs-6">
                    {t("Contact-us")}
                  </button>
                </Link>
              </div>
            </div>

            {/* Image Section */}
            <div className="col-lg-6 col-12 image-content px-3 order-1 order-lg-2 mb-3">
              <img
                src={data?.image || AboutHead}
                alt="About"
                className="img rounded shadow w-100"
                style={{ height: "240px", objectFit: "cover" }}
              />
            </div>
          </div>
        </section>
      </div>

      {/* Section 2 - Video + Short Description */}
      <div className="px-2 mb-5 my-3">
        <section className="about-section container">
          <div className="row align-items-center">
            {/* Video */}
            <div className="col-lg-6 col-12 image-content h-100 px-3">
              <iframe
                width="100%"
                height="293px"
                src="https://www.youtube.com/embed/9mcz8NKt3kY?si=iMWZOlApJFpeCQhb"
                title="Amzio Intro Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              ></iframe>
            </div>

            {/* Short Description */}
            <div className="col-lg-6 col-12 text-content px-3 mt-2">
              <div
                className="text-muted fs-6"
                dangerouslySetInnerHTML={{ __html: data?.short_desc || "" }}
              ></div>

              <div className="animate__animated animate__fadeInUp mt-3">
                <Link to="/ask-a-questions">
                  <button className="btn theme-btn style-one btn-lg fs-6">
                    {t("Support-Center")}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutUs;
